import { axios } from '@/services/axios';

const getCountry = (countryId) => {
    return axios.get(`/country/${countryId}`);
};

export default getCountry;
